import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.to-string.js";
import { STATUS_CODE } from './websee/types';

/**
 * 检测页面是否白屏
 * @param {function} callback - 回调函数获取检测结果
 * @param {object} options - 配置选项
 * @param {array} options.whiteBoxElements - 容器列表
 * @param {number} options.duration - 检测时长（毫秒），时长结束后返回一次结果
 * @param {boolean} options.debug - 是否启用调试模式，显示采样点
 * @param {number} options.threshold - 阈值，需要至少有多少个非容器点才视为正常，默认5
 */
export function openWhiteScreen(callback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 6000 : _ref$duration,
    _ref$whiteBoxElements = _ref.whiteBoxElements,
    whiteBoxElements = _ref$whiteBoxElements === void 0 ? ['html', 'body', '#app', '#root'] : _ref$whiteBoxElements,
    _ref$debug = _ref.debug,
    debug = _ref$debug === void 0 ? false : _ref$debug,
    _ref$threshold = _ref.threshold,
    threshold = _ref$threshold === void 0 ? 5 : _ref$threshold;
  // 验证阈值参数
  if (threshold < 1 || threshold > 17) {
    threshold = Math.max(1, Math.min(17, threshold));
  }

  // 兜底定时器
  var _durationTimer = null;
  // 轮询定时器
  var _loopTimer = null;
  // 是否已回调过结果
  var _hasCallbackFired = false;
  // 当前调试状态
  var currentDebug = debug;

  // 挂载全局调试控制函数
  if (typeof window !== 'undefined') {
    window.__WHITE_SCREEN_DEBUG__ = {
      enable: function enable() {
        if (!currentDebug) {
          currentDebug = true;
          createDebugPoints();
          performSampling();
        }
      },
      disable: function disable() {
        if (currentDebug) {
          currentDebug = false;
          var container = document.getElementById('white-screen-debug-container');
          if (container) container.remove();
        }
      }
    };
  }
  var startDetection = function startDetection() {
    _cleanup();

    // 立即执行第一次检测
    var initialResult = performSampling();
    if (initialResult.status === STATUS_CODE.OK) {
      // 立即回调正常结果
      callback(initialResult);
      _hasCallbackFired = true;
      _cleanup();
      return;
    }
    openWhiteLoop();

    // 兜底定时器：duration 结束后仍未恢复，回调白屏结果
    _durationTimer = window.setTimeout(function () {
      if (!_hasCallbackFired) {
        var finalResult = performSampling();
        _hasCallbackFired = true;
        callback(finalResult);
      }
      _cleanup();
    }, duration);
  };

  // 处理页面可见性
  var _visibilityHandler = null;
  var hiddenTimeout = null;
  if (document.visibilityState === 'hidden') {
    _visibilityHandler = function visibilityHandler() {
      if (document.visibilityState === 'visible') {
        if (hiddenTimeout) clearTimeout(hiddenTimeout);
        document.removeEventListener('visibilitychange', _visibilityHandler);
        setTimeout(function () {
          startDetection();
        }, 300);
      }
    };
    document.addEventListener('visibilitychange', _visibilityHandler, {
      once: false
    });

    // 超时处理
    hiddenTimeout = window.setTimeout(function () {
      document.removeEventListener('visibilitychange', _visibilityHandler);
      startDetection();
    }, 5000);
  } else {
    startDetection();
  }

  // 清理函数
  function _cleanup() {
    if (_loopTimer) {
      clearInterval(_loopTimer);
      _loopTimer = null;
    }
    if (_durationTimer) {
      clearTimeout(_durationTimer);
      _durationTimer = null;
    }

    // 清理 visibilitychange 监听器
    if (_visibilityHandler) {
      document.removeEventListener('visibilitychange', _visibilityHandler);
    }
    if (hiddenTimeout) {
      clearTimeout(hiddenTimeout);
    }
  }

  // 获取选择器的函数
  function getSelector(element) {
    if (!element) return '';
    if (element.id) {
      return '#' + element.id;
    } else if (element.className) {
      var classNameStr = '';
      if (typeof element.className === 'string') {
        classNameStr = element.className;
      } else if (element.className && _typeof(element.className) === 'object' && 'baseVal' in element.className) {
        var svgClassName = element.className;
        classNameStr = svgClassName.baseVal || '';
      }
      if (classNameStr) {
        var className = classNameStr.split(' ').filter(function (item) {
          return !!item;
        }).join('.');
        return '.' + className;
      }
    } else if (element.nodeName) {
      return element.nodeName.toLowerCase();
    }
    return '';
  }

  // 判断是否为容器（包含骨架屏元素）
  function isContainer(element) {
    var selector = getSelector(element);

    // 检查是否是骨架屏元素
    var isSkeletonElement = element.namespaceURI === 'http://www.w3.org/2000/svg';

    // 检查是否在白名单中
    var isWhiteBoxElement = whiteBoxElements === null || whiteBoxElements === void 0 ? void 0 : whiteBoxElements.some(function (w) {
      // 支持模糊匹配，比如 '#app' 匹配 '#app' 开头的选择器
      return selector === w || selector.startsWith(w + ' ');
    });
    return isWhiteBoxElement || isSkeletonElement;
  }

  // 检查元素是否是调试元素
  function isDebugElement(element) {
    if (!element) return false;
    if (!currentDebug) return false;
    var id = element.id || '';
    if (typeof id === 'string' && id.includes('white-screen')) {
      return true;
    }
    var className = element.className;
    if (className) {
      var classNameStr = '';
      if (typeof className === 'string') {
        classNameStr = className;
      } else if (className && _typeof(className) === 'object' && 'baseVal' in className) {
        var svgClassName = className;
        classNameStr = svgClassName.baseVal || '';
      }
      if (typeof classNameStr === 'string' && classNameStr.includes('white-screen')) {
        return true;
      }
    }

    // 检查是否在调试容器内
    if (element.closest('#white-screen-debug-container')) {
      return true;
    }
    return false;
  }

  // 执行采样检测，返回结果但不触发回调
  function performSampling() {
    var start = performance.now();
    if (currentDebug) {
      createDebugPoints();
    }
    var emptyPoints = 0;

    // 采样点索引
    var pointIndex = 1;

    // 第一轮：水平线采样 (9个点)
    for (var i = 1; i <= 9; i++) {
      var x = window.innerWidth * i / 10;
      var y = window.innerHeight / 2;
      var elements = document.elementsFromPoint(x, y);
      var nonDebugElements = currentDebug ? elements.filter(function (el) {
        return !isDebugElement(el);
      }) : elements;
      var targetElement = nonDebugElements[0];
      var isContainerElement = targetElement ? isContainer(targetElement) : true;
      if (isContainerElement) emptyPoints++;
      if (currentDebug) {
        updateDebugPoint(x, y, pointIndex, isContainerElement);
      }
      pointIndex++;
    }

    // 第二轮：垂直线采样
    for (var _i = 1; _i <= 9; _i++) {
      if (_i === 5) continue; // 跳过中心点，因为水平线已经采样过了

      var _x = window.innerWidth / 2;
      var _y = window.innerHeight * _i / 10;
      var _elements = document.elementsFromPoint(_x, _y);
      var _nonDebugElements = currentDebug ? _elements.filter(function (el) {
        return !isDebugElement(el);
      }) : _elements;
      var _targetElement = _nonDebugElements[0];
      var _isContainerElement = _targetElement ? isContainer(_targetElement) : true;
      if (_isContainerElement) emptyPoints++;
      if (currentDebug) {
        updateDebugPoint(_x, _y, pointIndex, _isContainerElement);
      }
      pointIndex++;
    }

    // 计算非容器点数量
    var totalPoints = 17;
    var nonContainerPoints = totalPoints - emptyPoints;
    var status = STATUS_CODE.OK;

    // 根据阈值判断
    if (nonContainerPoints >= threshold) {
      status = STATUS_CODE.OK; // 非容器点数量达到阈值，视为正常
    } else {
      status = STATUS_CODE.ERROR; // 非容器点数量未达到阈值，视为白屏
    }

    if (currentDebug) {
      updateDebugInfo(emptyPoints, totalPoints, nonContainerPoints, threshold, status);
    }
    return {
      status: status,
      emptyPoints: emptyPoints,
      nonContainerPoints: nonContainerPoints
    };
  }

  // 检测函数结果
  function sampling() {
    var result = performSampling();
    if (result.status === STATUS_CODE.OK) {
      if (!_hasCallbackFired) {
        _hasCallbackFired = true;
        callback(result);
      }
      _cleanup();
    }
  }

  // 开启白屏轮训
  function openWhiteLoop() {
    if (_loopTimer) return;
    _loopTimer = window.setInterval(function () {
      idleCallback();
    }, 1000);
  }

  // 浏览器空闲时执行采样操作，轮询检测保证检测频率的同时减少对性能的影响
  function idleCallback() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function (deadline) {
        if (deadline.timeRemaining() > 0) {
          sampling();
        }
      });
    } else {
      sampling();
    }
  }

  // 调试相关函数
  function createDebugPoints() {
    // 检查是否已经存在调试容器
    var container = document.getElementById('white-screen-debug-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'white-screen-debug-container';
      container.style.cssText = "\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        pointer-events: none;\n        z-index: 999999;\n      ";
      document.body.appendChild(container);

      // 创建信息面板
      var infoPanel = document.createElement('div');
      infoPanel.id = 'white-screen-info-panel';
      infoPanel.style.cssText = "\n        position: fixed;\n        bottom: 20px;\n        right: 20px;\n        background: rgba(0, 0, 0, 0.85);\n        color: white;\n        padding: 15px;\n        border-radius: 8px;\n        font-family: Arial, sans-serif;\n        font-size: 14px;\n        z-index: 1000000;\n        max-width: 300px;\n        pointer-events: auto;\n        border-left: 4px solid #00d2ff;\n      ";
      var closeBtn = document.createElement('button');
      closeBtn.innerHTML = '×';
      closeBtn.title = '关闭调试';
      closeBtn.style.cssText = "\n        position: absolute;\n        top: 5px;\n        right: 5px;\n        background: #ff4757;\n        color: white;\n        border: none;\n        border-radius: 50%;\n        width: 20px;\n        height: 20px;\n        cursor: pointer;\n        font-size: 12px;\n        line-height: 1;\n      ";
      closeBtn.onclick = function () {
        if (window.__WHITE_SCREEN_DEBUG__) {
          window.__WHITE_SCREEN_DEBUG__.disable();
        } else {
          var _container;
          (_container = container) === null || _container === void 0 ? void 0 : _container.remove();
          currentDebug = false;
        }
      };
      var title = document.createElement('h3');
      title.textContent = '白屏检测采样点';
      title.style.cssText = "\n        margin: 0 0 10px 0;\n        color: #00d2ff;\n        font-size: 16px;\n      ";
      infoPanel.appendChild(closeBtn);
      infoPanel.appendChild(title);
      container.appendChild(infoPanel);
    }

    // 创建采样点容器
    var pointsContainer = document.getElementById('white-screen-points');
    if (!pointsContainer) {
      pointsContainer = document.createElement('div');
      pointsContainer.id = 'white-screen-points';
      container.appendChild(pointsContainer);
    }
  }
  function updateDebugPoint(x, y, index, isContainer) {
    var pointsContainer = document.getElementById('white-screen-points');
    if (!pointsContainer) return;
    var point = document.getElementById("white-screen-point-".concat(index));
    if (!point) {
      point = document.createElement('div');
      point.id = "white-screen-point-".concat(index);
      point.style.cssText = "\n        position: absolute;\n        width: 12px;\n        height: 12px;\n        border-radius: 50%;\n        transform: translate(-50%, -50%);\n        left: ".concat(x, "px;\n        top: ").concat(y, "px;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n        z-index: 999999;\n      ");
      var _number = document.createElement('div');
      _number.textContent = index.toString();
      _number.style.cssText = "\n        position: absolute;\n        top: -20px;\n        left: 50%;\n        transform: translateX(-50%);\n        font-size: 10px;\n        font-weight: bold;\n        text-shadow: 0 1px 2px rgba(0,0,0,0.5);\n        white-space: nowrap;\n        opacity: 0;\n        transition: opacity 0.3s;\n      ";
      point.appendChild(_number);
      pointsContainer.appendChild(point);
    }

    // 根据是否容器设置颜色
    var color = isContainer ? '#ff4757' : '#2ed573';
    point.style.backgroundColor = color;
    point.style.border = "2px solid ".concat(color);
    var number = point.querySelector('div');
    if (number) {
      number.style.color = color;
      number.style.opacity = '1';
    }
  }
  function updateDebugInfo(emptyPoints, totalPoints, nonContainerPoints, threshold, status) {
    var infoPanel = document.getElementById('white-screen-info-panel');
    if (!infoPanel) return;

    // 查找或创建统计信息
    var stats = infoPanel.querySelector('.white-screen-stats');
    if (!stats) {
      stats = document.createElement('div');
      stats.className = 'white-screen-stats';
      stats.style.cssText = "\n        margin-top: 10px;\n        padding: 10px;\n        background: rgba(255, 255, 255, 0.1);\n        border-radius: 4px;\n      ";
      infoPanel.appendChild(stats);
    }
    var statusText = status === STATUS_CODE.ERROR ? '❌ 可能白屏' : '✅ 正常';
    var statusColor = status === STATUS_CODE.ERROR ? '#ff4757' : '#2ed573';

    // 阈值状态指示
    var thresholdStatus = nonContainerPoints >= threshold ? '✅ 达标' : '❌ 未达标';
    var thresholdColor = nonContainerPoints >= threshold ? '#2ed573' : '#ff4757';
    stats.innerHTML = "\n      <div>\u91C7\u6837\u70B9: ".concat(totalPoints, "\u4E2A</div>\n      <div>\u5BB9\u5668\u70B9: ").concat(emptyPoints, "\u4E2A</div>\n      <div>\u975E\u5BB9\u5668\u70B9: ").concat(nonContainerPoints, "\u4E2A</div>\n      <div style=\"margin-top: 5px;\">\n        \u9608\u503C: ").concat(threshold, "\u4E2A\n        <span style=\"color: ").concat(thresholdColor, "; font-weight: bold; margin-left: 10px;\">\n          ").concat(thresholdStatus, "\n        </span>\n      </div>\n      <div style=\"margin-top: 10px; color: ").concat(statusColor, "; font-weight: bold; font-size: 16px;\">\n        ").concat(statusText, "\n      </div>\n    ");
  }
  return {
    cleanup: function cleanup() {
      _cleanup();
      if (currentDebug) {
        var container = document.getElementById('white-screen-debug-container');
        if (container) {
          container.remove();
        }
      }
      if (typeof window !== 'undefined' && window.__WHITE_SCREEN_DEBUG__) {
        delete window.__WHITE_SCREEN_DEBUG__;
      }
    }
  };
}